<div [class]="'notifications ' + 'notifications-' + position">
    <ng-container *ngFor="let notification of notificationList | async">
        <app-custom-notification
            [notification]="notification"
            *ngIf="notification"
        ></app-custom-notification>
    </ng-container>
</div>
